import { render, staticRenderFns } from "./privacyAuth.vue?vue&type=template&id=7f937210&"
import script from "./privacyAuth.vue?vue&type=script&lang=js&"
export * from "./privacyAuth.vue?vue&type=script&lang=js&"
import style0 from "./privacyAuth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports